export default __webpack_public_path__ + "static/foyer-de-masse-3712fa43bfb23b994212e839bce77b72.jpg";